// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingbox-container {
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center;
    gap: 10px;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
}

/* Generated Spinner CSS */
@keyframes ldio-mx77hswobgl {
  0% {
    top: 46px;
    left: 46px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 8px;
    left: 8px;
    width: 76px;
    height: 76px;
    opacity: 0;
  }
}.ldio-mx77hswobgl div {
  position: absolute;
  border-width: 8px;
  border-style: solid;
  opacity: 1;
  border-radius: 50%;
  animation: ldio-mx77hswobgl 1s cubic-bezier(0,0.2,0.8,1) infinite;
}.ldio-mx77hswobgl div:nth-child(1) {
  border-color: var(--loadingColor1);
  animation-delay: 0s;
}
.ldio-mx77hswobgl div:nth-child(2) {
  border-color: var(--loadingColor2);
  animation-delay: -0.5s;
}
.loadingio-spinner-ripple-zavvin6qy4 {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: transparent;
}
.ldio-mx77hswobgl {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-mx77hswobgl div { box-sizing: content-box; }`, "",{"version":3,"sources":["webpack://./src/styles/general/Loading.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF,CAAC;EACC,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,iEAAiE;AACnE,CAAC;EACC,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,2BAA2B;EAC3B,qBAAqB,EAAE,mBAAmB;AAC5C;AACA,wBAAwB,uBAAuB,EAAE","sourcesContent":[".loadingbox-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center; \n    justify-content: center;\n    gap: 10px;\n    pointer-events: none;\n    user-select: none;\n}\n\n/* Generated Spinner CSS */\n@keyframes ldio-mx77hswobgl {\n  0% {\n    top: 46px;\n    left: 46px;\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    top: 8px;\n    left: 8px;\n    width: 76px;\n    height: 76px;\n    opacity: 0;\n  }\n}.ldio-mx77hswobgl div {\n  position: absolute;\n  border-width: 8px;\n  border-style: solid;\n  opacity: 1;\n  border-radius: 50%;\n  animation: ldio-mx77hswobgl 1s cubic-bezier(0,0.2,0.8,1) infinite;\n}.ldio-mx77hswobgl div:nth-child(1) {\n  border-color: var(--loadingColor1);\n  animation-delay: 0s;\n}\n.ldio-mx77hswobgl div:nth-child(2) {\n  border-color: var(--loadingColor2);\n  animation-delay: -0.5s;\n}\n.loadingio-spinner-ripple-zavvin6qy4 {\n  width: 100px;\n  height: 100px;\n  display: inline-block;\n  overflow: hidden;\n  background: transparent;\n}\n.ldio-mx77hswobgl {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transform: translateZ(0) scale(1);\n  backface-visibility: hidden;\n  transform-origin: 0 0; /* see note above */\n}\n.ldio-mx77hswobgl div { box-sizing: content-box; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
